/**
 * One card per media kind (`136:950`): the kind's name, its collection summary and an on/off
 * switch in the header, and the kind's own editor underneath while it collects.
 */

import type { ReactNode } from 'react';

import { cardsCatalogue } from '../../editor/cards.messages';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../ui/card';
import { Switch } from '../../../../ui/switch';
import { profileCatalogue } from './messages';

type Kind = 'POST' | 'REEL' | 'STORY' | 'AUDIO';

export function KindCardFrame(props: {
  kind: Kind;
  enabled: boolean;
  onToggle: () => void;
  /** Shown beside the switch while the kind collects. */
  summary: ReactNode;
  children: ReactNode;
}): ReactNode {
  const { kind, enabled, onToggle, summary, children } = props;
  const label = cardsCatalogue.t(`kind.${kind}`);

  return (
    <Card role="group" aria-label={label} className="kind-card" data-enabled={enabled}>
      <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2">
        <CardTitle>
          <h3 className="text-sm font-medium">{label}</h3>
        </CardTitle>
        <div className="flex min-w-0 items-center gap-2">
          <span className="min-w-0 text-xs text-muted-foreground" data-testid={`summary-${kind}`}>
            {enabled ? summary : profileCatalogue.t('kind.off')}
          </span>
          <Switch checked={enabled} onCheckedChange={onToggle} aria-label={label} />
        </div>
      </CardHeader>
      {enabled && <CardContent>{children}</CardContent>}
    </Card>
  );
}
